export default __webpack_public_path__ + "contentmodules/UCS_Sign_In_Platinum9786b97b3c040f2d23f5e95f7e86590a.png";